<div class="new-search-bar">
  <div class="container mt-4 mb-5">
    <div class="top-bar background-wrapper mb-2 col-md-12">
      <div class="d-flex">
        <div
          (click)="navigateBack()"
          class="icon-back d-flex align-items-center justify-content-center pe-3"
          height="20"
          role="button"
        >
          <span class="bright">
            <app-arrow-forward-svg></app-arrow-forward-svg>
          </span>
        </div>
        <div class="icon justify-content-center align-items-center">
          <img
            class="search_icon"
            src="assets/images/search_check.svg"
            alt=""
          />
        </div>
        <div class="heading ps-3">
          <div class="doc-wrapper">
            <span class="heading-line">
              Search Results for keyword : "{{ searchKey || "" }}"
            </span>
          </div>
          <div>
            <span class="sub-header-line">
              {{ "global-search.totalResults" | translate }}
              <span class="digit"> {{ "(" + totalCount + ")" }} </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper background-wrapper p-0 col-md-12 mt-2">
      <div class="search-tabs ps-2 ps-sm-4">
        <div class="d-flex tab-wrapper-search">
          <div
            (click)="selectTab('all')"
            class="tab cursor-pointer"
            [ngClass]="{ 'is-active': selectedTab === 'all' }"
          >
            {{ "global-search.all" | translate }}
            <span>
              ({{
                (servicesList?.length || 0) +
                  (departmentList?.length || 0) +
                  (schemeList?.length || 0)
              }})
            </span>
          </div>
          <div
            (click)="selectTab('service')"
            class="tab cursor-pointer"
            [ngClass]="{ 'is-active': selectedTab === 'service' }"
          >
            {{ "global-search.services" | translate }}
            <span> ({{ servicesList?.length || 0 }}) </span>
          </div>
          <div
            (click)="selectTab('department')"
            class="tab cursor-pointer"
            [ngClass]="{ 'is-active': selectedTab === 'department' }"
          >
            {{ "global-search.departments" | translate }}
            <span> ({{ departmentList?.length || 0 }}) </span>
          </div>
          <div
            (click)="selectTab('scheme')"
            class="tab cursor-pointer"
            [ngClass]="{ 'is-active': selectedTab === 'scheme' }"
          >
            {{ "global-search.schemes" | translate
            }}<span> ({{ schemeList?.length || 0 }}) </span>
          </div>

          <div
            (click)="selectTab('digilocker')"
            class="tab cursor-pointer"
            [ngClass]="{ 'is-active': selectedTab === 'digilocker' }"
          >
            {{ "global-search.digilocker" | translate }}
            <span> ({{ digiLockerList?.length || 0 }}) </span>
          </div>
        </div>
      </div>
      <div class="content-container" id="scrollId">
        <div *ngIf="selectedTab === 'department'">
          <div
            class="document-detail ps-4 pe-4 pb-3 pt-3"
            *ngFor="let document of departmentList"
          >
            <div
              (click)="navigateToDeptInfo(document, 'department')"
              class="d-flex cursor-pointer"
            >
              <div class="icon">
                <img
                  [src]="document.logo_url"
                  onerror="this.src='assets/images/placeholder.svg'"
                  alt=""
                />
              </div>
              <div class="doc-name ps-3">
                <div class="doc-wrapper">
                  <span class="heading-line">
                    {{ document.department_name }}
                  </span>
                </div>
                <div class="text-ellipsis-truncate">
                  <span class="sub-heading-line">
                    {{ document.long_description }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="departmentsCount === 0 && dataIsNotLoaded">
            <app-no-data
              [isError]="false"
              [errorMessage]="'global-search.noDepartment'"
            ></app-no-data>
          </div>

          <app-skeleton-loader
            *ngIf="!dataIsNotLoaded"
            [loaderType]="'state-loader'"
            [filterLoader]="'list-rectangle'"
          ></app-skeleton-loader>
        </div>

        <div *ngIf="selectedTab === 'service'">
          <div
            class="document-detail ps-4 pr-4 pb-3 pt-3"
            *ngFor="let document of servicesList"
          >
            <div
              (click)="navigateToDeptInfo(document, 'service')"
              class="d-flex cursor-pointer"
            >
              <div class="icon">
                <img
                  [src]="document.image_url"
                  onerror="this.src='assets/images/placeholder.svg'"
                  alt=""
                />
              </div>
              <div class="doc-name ps-3">
                <div class="doc-wrapper">
                  <span class="heading-line">
                    {{ document.service_name }}
                  </span>
                </div>
                <div class="text-ellipsis-truncate">
                  <span class="sub-heading-line">
                    {{ document.department_name }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="servicesCount === 0 && dataIsNotLoaded">
            <app-no-data
              [isError]="false"
              [errorMessage]="'global-search.noServices'"
            ></app-no-data>
          </div>

          <app-skeleton-loader
            *ngIf="!dataIsNotLoaded"
            [loaderType]="'state-loader'"
            [filterLoader]="'list-rectangle'"
          ></app-skeleton-loader>
        </div>

        <div
          class="scheme-wrapper-container local-container"
          *ngIf="selectedTab === 'scheme'"
        >
          <div
            class="scheme-container ps-4 pe-4 pb-4"
            *ngFor="let scheme of schemeList"
          >
            <div class="scheme-title d-flex justify-content-between">
              <div class="title-header">
                {{
                  scheme.nodal_ministry_name
                    ? scheme.nodal_ministry_name
                    : scheme.beneficiary_state[0]
                }}
              </div>
              <!-- <div class="bookmark-icon cursor-pointer">
              <img src="assets/img/bookmark_orange_unselected.svg" alt="">
            </div> -->
            </div>

            <div
              (click)="navigateToSchemeDetail(scheme)"
              class="cursor-pointer"
            >
              <div class="scheme-name-wrapper">
                <span>
                  {{ scheme.scheme_name }}
                </span>
              </div>

              <div class="scheme-desc-wrapper">
                <span>
                  {{ scheme.brief_description }}
                </span>
              </div>

              <div class="scheme-tags-wrapper">
                <div *ngFor="let tag of scheme.scheme_tags">
                  <span>
                    {{ tag }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="schemesCount === 0">
            <app-no-data
              [isError]="false"
              [errorMessage]="'global-search.noScheme'"
            ></app-no-data>
          </div>
        </div>

        <div *ngIf="selectedTab === 'all'">
          <div *ngIf="servicesList?.length">
            <div class="header-label">
              <div class="title">
                {{ "global-search.services" | translate }}
              </div>
              <div
                *ngIf="servicesCount >= 3"
                (click)="selectTab('service')"
                class="view-all-count cursor-pointer"
              >
                {{ "global-search.viewAll" | translate }} ({{ servicesCount }})
              </div>
            </div>
            <div>
              <div
                class="document-detail ps-4 pr-4 pb-3 pt-3"
                *ngFor="let document of servicesList?.slice(0, 3)"
              >
                <div
                  (click)="navigateToDeptInfo(document, 'service')"
                  class="d-flex cursor-pointer"
                >
                  <div class="icon">
                    <img
                      [src]="document.image_url"
                      onerror="this.src='assets/images/placeholder.svg'"
                      alt=""
                    />
                  </div>
                  <div class="doc-name ps-3">
                    <div class="doc-wrapper">
                      <span class="heading-line">
                        {{ document.service_name }}
                      </span>
                    </div>
                    <div>
                      <span class="sub-heading-line line-clamp-2">
                        {{ document.department_name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="servicesCount === 0 && dataIsNotLoaded">
                <app-no-data
                  [isError]="false"
                  [errorMessage]="'pages.noServices'"
                ></app-no-data>
              </div>

              <app-skeleton-loader
                *ngIf="!dataIsNotLoaded"
                [loaderType]="'state-loader'"
                [filterLoader]="'list-rectangle'"
              ></app-skeleton-loader>
            </div>
          </div>

          <div *ngIf="departmentList?.length">
            <div class="header-label">
              <div class="title">
                {{ "global-search.departments" | translate }}
              </div>
              <div
                *ngIf="departmentsCount >= 3"
                (click)="selectTab('department')"
                class="view-all-count cursor-pointer"
              >
                {{ "global-search.viewAll" | translate }} (
                {{ departmentsCount }} )
              </div>
            </div>
            <div>
              <div
                class="document-detail ps-4 pr-4 pb-3 pt-3"
                *ngFor="let document of departmentList?.slice(0, 3)"
              >
                <div
                  (click)="navigateToDeptInfo(document, 'department')"
                  class="d-flex cursor-pointer"
                >
                  <div class="icon">
                    <img
                      [src]="document.logo_url"
                      onerror="this.src='assets/images/placeholder.svg'"
                      alt=""
                    />
                  </div>
                  <div class="doc-name ps-3">
                    <div class="doc-wrapper">
                      <span class="heading-line">
                        {{ document.department_name }}
                      </span>
                    </div>
                    <div>
                      <span class="sub-heading-line line-clamp-2">
                        {{ document.long_description }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="departmentsCount === 0 && dataIsNotLoaded">
                <app-no-data
                  [isError]="false"
                  [errorMessage]="'pages.noDepartment'"
                ></app-no-data>
              </div>

              <app-skeleton-loader
                *ngIf="!dataIsNotLoaded"
                [loaderType]="'state-loader'"
                [filterLoader]="'list-rectangle'"
              ></app-skeleton-loader>
            </div>
          </div>

          <div *ngIf="schemeList?.length">
            <div class="header-label">
              <div class="title">
                {{ "global-search.schemes" | translate }}
              </div>
              <div
                *ngIf="schemesCount >= 3"
                (click)="selectTab('scheme')"
                class="view-all-count cursor-pointer"
              >
                {{ "global-search.viewAll" | translate }} ({{ schemesCount }})
              </div>
            </div>
            <div class="scheme-wrapper-container local-container">
              <div
                class="scheme-container ps-4 pr-4 pb-4"
                *ngFor="let scheme of schemeList?.slice(0, 3)"
              >
                <div class="scheme-title d-flex justify-content-between">
                  <div class="title-header">
                    {{
                      scheme.nodal_ministry_name
                        ? scheme.nodal_ministry_name
                        : scheme.beneficiary_state[0]
                    }}
                  </div>
                  <!-- <div class="bookmark-icon cursor-pointer">
              <img src="assets/img/bookmark_orange_unselected.svg" alt="">
            </div> -->
                </div>

                <div
                  (click)="navigateToSchemeDetail(scheme)"
                  class="cursor-pointer"
                >
                  <div class="scheme-name-wrapper">
                    <span>
                      {{ scheme.scheme_name }}
                    </span>
                  </div>

                  <div class="scheme-desc-wrapper">
                    <span>
                      {{ scheme.brief_description }}
                    </span>
                  </div>

                  <div class="scheme-tags-wrapper">
                    <div *ngFor="let tag of scheme.scheme_tags">
                      <span>
                        {{ tag }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="schemesCount === 0">
                <app-no-data
                  [isError]="false"
                  [errorMessage]="'pages.scheme.noScheme'"
                ></app-no-data>
              </div>
            </div>
          </div>

          <div *ngIf="digiLockerList?.length">
            <div class="header-label">
              <div class="title">
                {{ "global-search.digilocker" | translate }}
              </div>
              <div
                *ngIf="digiLockerCount >= 3"
                (click)="selectTab('digilocker')"
                class="view-all-count cursor-pointer"
              >
                {{ "global-search.viewAll" | translate }} ({{
                  digiLockerCount
                }})
              </div>
            </div>
            <div
              class="document-detail ps-4 pe-4 pb-3 pt-3"
              *ngFor="let document of digiLockerList?.slice(0, 3)"
            >
              <div
                (click)="navigateToDigilocker()"
                class="d-flex cursor-pointer"
              >
                <div class="icon">
                  <img
                    loading="lazy"
                    fetchpriority="high"
                    [src]="document.logo"
                    onerror="this.src='https://media.umangapp.in/cdn/web/theme/icons/placeholder.svg'"
                    alt=""
                  />
                </div>
                <div class="doc-name ps-3">
                  <div class="doc-wrapper">
                    <span class="heading-line">
                      {{ document.doc_desc }}
                    </span>
                  </div>
                  <div>
                    <span class="sub-heading-line line-clamp-2">
                      {{ document.name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="digiLockerCount === 0 && dataIsNotLoaded">
              <app-no-data
                [isError]="false"
                [errorMessage]="'pages.noServices'"
              ></app-no-data>
            </div>

            <app-skeleton-loader
              *ngIf="!dataIsNotLoaded"
              [loaderType]="'state-loader'"
              [filterLoader]="'list-rectangle'"
            ></app-skeleton-loader>
          </div>

          <div
            *ngIf="
              !schemeList?.length &&
              !departmentList?.length &&
              !servicesList?.length
            "
          >
            <app-no-data
              [isError]="false"
              [errorMessage]="'global-search.no-records-found'"
            ></app-no-data>
          </div>
        </div>

        <div *ngIf="selectedTab === 'digilocker'">
          <div
            class="document-detail ps-4 pe-4 pb-3 pt-3"
            *ngFor="let document of digiLockerList"
          >
            <div class="d-flex cursor-pointer">
              <div class="icon">
                <img
                  loading="lazy"
                  fetchpriority="high"
                  [src]="document.logo"
                  onerror="this.src='https://media.umangapp.in/cdn/web/theme/icons/placeholder.svg'"
                  alt=""
                />
              </div>
              <div (click)="navigateToDigilocker()" class="doc-name ps-3">
                <div class="doc-wrapper">
                  <span class="heading-line">
                    {{ document.doc_desc }}
                  </span>
                </div>
                <div>
                  <span class="sub-heading-line line-clamp-2">
                    {{ document.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="digiLockerCount === 0 && dataIsNotLoaded">
            <app-no-data
              [isError]="false"
              [errorMessage]="'pages.digiLocker-noDocumentFound'"
            ></app-no-data>
          </div>

          <app-skeleton-loader
            *ngIf="!dataIsNotLoaded"
            [loaderType]="'state-loader'"
            [filterLoader]="'list-rectangle'"
          >
          </app-skeleton-loader>
        </div>

        <app-skeleton-loader
          *ngIf="!dataIsNotLoaded"
          [loaderType]="'state-loader'"
          [filterLoader]="'list-rectangle'"
        ></app-skeleton-loader>
      </div>
    </div>
  </div>
</div>
